import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/MoreThanCuteSection.css';

function MoreThanCuteSection({ isMobile }) {
  const { t } = useTranslation();
  
  const sectionStyle = !isMobile ? {
    backgroundImage: 'url("/images/more-than-cute.png")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  } : {};

  return (
    <section 
      className="more-than-cute-section" 
      id="fashion"
      style={sectionStyle}
    >
      <div className="more-than-cute-container">
        <h2 className="more-than-cute-title">{t('moreThanCute.title')}</h2>
      </div>
    </section>
  );
}

export default MoreThanCuteSection; 